export default __webpack_public_path__ + "static/media/startlater_2@2x.e9cc4eb5.jpg";